interface ChangeIndicatorProps {
	value: number | null | undefined;
}

export function ChangeIndicator({ value }: ChangeIndicatorProps) {
	if (value == null) {
		return <span className="text-xs text-muted">–</span>;
	}

	const percent = Math.abs(value * 100).toFixed(1);

	if (value > 0) {
		return (
			<span className="inline-flex items-center rounded-full bg-green-50 px-1.5 py-0.5 text-xs font-semibold text-green-700">
				▲ {percent} %
			</span>
		);
	}
	if (value < 0) {
		return (
			<span className="inline-flex items-center rounded-full bg-red-50 px-1.5 py-0.5 text-xs font-semibold text-red-700">
				▼ {percent} %
			</span>
		);
	}
	return <span className="text-xs text-muted">0 %</span>;
}
